import ControlFeesSettingsPage from "./controlFeesSettings";

export default ControlFeesSettingsPage;